import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
// Web3Modal and wallet connection removed - using direct wallet address input
import HomePage from './pages/HomePage';
import WinnersPage from './pages/WinnersPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import WhitepaperPage from './pages/WhitepaperPage';
import Header from './components/Header';
import Footer from './components/Footer';
import { theme } from './styles/theme';
import { GlobalStyle } from './styles/GlobalStyle';
import { HelmetProvider } from 'react-helmet-async';

// Wallet address will be collected via input field

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
`;

const MainContent = styled.main`
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <HelmetProvider>
        <Router>
          <AppContainer>
            <Header />
            <MainContent>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/winners" element={<WinnersPage />} />
                <Route path="/whitepaper" element={<WhitepaperPage />} />
                <Route path="/payment-callback" element={<PaymentCallbackPage />} />
              </Routes>
            </MainContent>
            <Footer />
          </AppContainer>
        </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
